import { ECountry } from '@portals/help-center-core';
import { EPageType } from '@/_analytic/_types';
import { getCategoriesRoute, getMaterialRoute } from '@/_constants/routes';
import { getCleanedArticleHref } from '../get-cleaned-article-href/get-cleaned-article-href';

type TProps = {
  pageType: EPageType;
  idArticle?: string;
  categoryId?: string;
  isRecommended?: boolean;
  country: ECountry;
};

export const getHref = ({
  pageType,
  idArticle,
  categoryId,
  isRecommended,
  country,
}: TProps): string => {
  const articleHref = getCleanedArticleHref(categoryId);

  const homeHref = getCategoriesRoute({ country });

  if (pageType === EPageType.ADVICE_LIST_ARTICLE && idArticle) {
    const baseUrl = getMaterialRoute({ country, materialId: idArticle });

    const categoryParam = `categoryId=${categoryId}`;
    const recommendedParam = 'recommended=true';
    const params = [
      categoryId ? categoryParam : '',
      isRecommended ? recommendedParam : '',
    ]
      .filter(Boolean)
      .join('&');

    return params ? `${baseUrl}?${params}` : baseUrl;
  }

  return pageType === EPageType.ARTICLE ? articleHref : homeHref;
};
